module.exports = __webpack_public_path__ + "img/logo-but-2.7671b9ba.png";